import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["should"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import buildRawQueryBase from './build-raw-query-base';
import getItemsToDisplayIds from './get-items-to-display-ids';
import getExtraAzBits from './get-extra-az-bits';
import buildAzFilter from './build-az-filter';
import { AND_OPERATOR, AZ_DEFAULT_PROP } from '../constants';
const buildRawQuery = ({
  docType,
  operator,
  searchValues = {},
  filterData,
  id,
  itemsToDisplay,
  shouldApplySort,
  azOptions
}) => {
  const {
    searchValuesText: {
      must: searchValuesText = [],
      should: shouldValuesText = []
    } = {},
    searchValuesCheckboxSelectRange = [],
    searchValuesCheckboxOr = []
  } = searchValues;
  const {
    filterValues,
    filterOperator,
    relations,
    stringProps,
    azFilter
  } = filterData;
  const {
    isAZ,
    sortProperties = []
  } = azOptions || {};
  const sortPropertyToUse = isAZ && sortProperties[0] && sortProperties[0].isScore ? 1 : 0;
  const {
    propsToDisplay: [azSortProp] = []
  } = sortProperties[sortPropertyToUse] || {
    propsToDisplay: []
  };
  const azSortProperty = azSortProp || AZ_DEFAULT_PROP;
  const searchValuesTextCheckboxSelectJoined = operator === AND_OPERATOR ? [...searchValuesText, ...searchValuesCheckboxSelectRange] : [];
  let searchValuesTextCheckboxOr = searchValuesText;
  if (searchValuesCheckboxOr.length) {
    searchValuesTextCheckboxOr = [...searchValuesText, ...searchValuesCheckboxOr];
  }
  let finalValue;
  if (searchValuesTextCheckboxSelectJoined.length) {
    const finalValueWithCheckboxOrValues = {
      must: [...searchValuesTextCheckboxSelectJoined, {
        bool: {
          should: searchValuesCheckboxOr
        }
      }]
    };
    const finalValueIfNoCheckboxOrValues = {
      must: searchValuesTextCheckboxSelectJoined
    };
    finalValue = searchValuesCheckboxOr.length ? finalValueWithCheckboxOrValues : finalValueIfNoCheckboxOrValues;
  } else {
    finalValue = {
      must: [...searchValuesCheckboxSelectRange, {
        bool: {
          should: [...searchValuesTextCheckboxOr, ...shouldValuesText]
        }
      }]
    };
  }
  const mustValues = [{
    bool: finalValue
  }];
  buildAzFilter(azFilter, mustValues, azSortProperty);
  const _buildRawQueryBase = buildRawQueryBase({
      docType,
      id,
      filterValues,
      filterOperator,
      relations,
      stringProps
    }),
    {
      should: baseShould = []
    } = _buildRawQueryBase,
    baseQuery = _objectWithoutProperties(_buildRawQueryBase, _excluded);
  const shouldValue = [...baseShould, ...shouldValuesText];
  const query = {
    bool: _objectSpread({
      must: mustValues,
      should: shouldValue.length ? shouldValue : undefined
    }, baseQuery)
  };
  const azQueryBits = getExtraAzBits(_objectSpread(_objectSpread({}, azOptions), {}, {
    azSortProperty,
    azFilter
  }));
  if (itemsToDisplay && itemsToDisplay.length) {
    const itemsToDisplayIds = getItemsToDisplayIds(itemsToDisplay);
    query.bool.must.push({
      ids: {
        values: itemsToDisplayIds
      }
    });
    if (shouldApplySort) {
      return _objectSpread({
        query,
        sort: [{
          _script: {
            type: 'number',
            script: {
              lang: 'painless',
              source: "!doc['id.keyword'].empty ? params.sortOrder.indexOf(doc['id.keyword'].value) : 0",
              params: {
                sortOrder: itemsToDisplayIds
              }
            },
            order: 'asc'
          }
        }]
      }, azQueryBits);
    }
  }
  return isAZ ? _objectSpread({
    query
  }, azQueryBits) : query;
};
export default buildRawQuery;
//# sourceMappingURL=build-raw-query.js.map